import { FlexContainer, Text } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const Label = styled(Text)`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`;

export const Container = styled(FlexContainer)`
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${({ theme }) => theme.system.fds_sys_spacing_XXS};
`;
